module.exports = __webpack_public_path__ + "static/media/the_mortgage_lender.14593132.png";